function Modal({ isActive, render, setIsActive }) {
  return (
    <div className={`modal ${isActive ? "is-active" : ""}`}>
      <div className="modal-background"></div>
      <div
        style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "center" }}
        className="modal-content"
      >
        {render()}
      </div>
      <button
        className="modal-close is-large"
        onClick={() => setIsActive(false)}
        aria-label="close"
      ></button>
    </div>
  );
}

export default Modal;
